import { StateCreator } from 'zustand';
import { FaqSlice } from './faq.types';

export const createFaqSlice: StateCreator<FaqSlice, [], [], FaqSlice> = () => ({
  faqData: null,
});
